<template>
  <NuxtLayout>
  <NuxtRouteAnnouncer />
  <NuxtPage />
  </NuxtLayout>
</template>

<style lang="scss">
@use "~/assets/mixins/_skeleton" as *;
@use "~/assets/mixins/_smooth-scroll" as *;

@include SkeletonBlockStyles;
@include SmoothScrollStyles;
</style>
